// HM-LAYOUT-FIX cluster 15.1 + cluster 15.3 + cluster 15.4 + cluster 15.5:
// rotta di preview AppLayout senza auth, estesa con KpiStrip e RoomGrid
// mock per validare visivamente il visual rework + micro-fix +
// sidebar/topbar fixed.

import { AppLayout } from '@hotel-manager/ui';
import { useState } from 'react';
import type { BookingDto, RoomDb } from '../../api/rooms.js';
import { KpiStrip } from '../../components/dashboard-v2/KpiStrip.js';
import { RoomGrid } from '../../components/dashboard-v2/RoomGrid.js';
import { sidebarItems } from '../../sidebar-items.js';

const MOCK_KPIS = {
  occupiedRooms: 8,
  totalRooms: 14,
  incomeTodayCents: 0,
  arrivalsToday: 5,
  arrivalsArriving: 2,
  departuresToday: 3,
  departuresExpiringSoon: 1,
  pendingOrders: 2,
  ordersPreparing: 1,
  roomsToClean: 3,
};

function makeRoom(code: string, status: RoomDb['status'], floor = '1', building = 'main'): RoomDb {
  return {
    id: `r-${code}`,
    tenantId: 't1',
    roomTypeId: 'rt1',
    code,
    floor,
    building,
    status,
    knxConfig: {},
    notes: null,
    createdAt: '2026-05-10T00:00:00Z',
    updatedAt: '2026-05-10T00:00:00Z',
  };
}

const MOCK_ROOMS: RoomDb[] = [
  makeRoom('101', 'free'),
  makeRoom('102', 'occupied'),
  makeRoom('103', 'reserved'),
  makeRoom('104', 'occupied'),
  makeRoom('105', 'free'),
  makeRoom('106', 'dirty'),
  makeRoom('107', 'occupied'),
  makeRoom('108', 'free', '1', 'annex'),
  makeRoom('109', 'occupied', '1', 'annex'),
  makeRoom('110', 'free', '1', 'annex'),
  makeRoom('111', 'reserved', '1', 'annex'),
  makeRoom('112', 'occupied', '1', 'annex'),
  makeRoom('113', 'free', '1', 'annex'),
  makeRoom('114', 'out_of_order', '1', 'annex'),
];
const MOCK_BOOKINGS: BookingDto[] = [];

export function LayoutPreview() {
  const [filter, setFilter] = useState<'all' | RoomDb['status']>('all');

  return (
    <AppLayout
      hotel={{ name: 'Hotel Mik', location: 'Nola, NA' }}
      user={{ name: 'Michele', role: 'Admin' }}
      sidebarItems={sidebarItems}
      activeItemId="dashboard"
      onItemSelect={() => {}}
      onLogout={() => {}}
      notificationCount={3}
    >
      <div className="px-6 pt-5 pb-6 space-y-5 flex-1">
        <KpiStrip kpis={MOCK_KPIS} />
        <div className="flex gap-2 mb-2">
          {(['all', 'free', 'reserved', 'occupied', 'dirty', 'out_of_order'] as const).map((v) => (
            <button
              key={v}
              type="button"
              onClick={() => setFilter(v)}
              className={`px-3 py-1.5 rounded-full text-xs border ${
                filter === v
                  ? 'bg-accent-soft border-accent-primary text-accent-primary-text font-semibold'
                  : 'bg-bg-card border-border-base text-text-secondary'
              }`}
            >
              {v}
            </button>
          ))}
        </div>
        <RoomGrid
          rooms={MOCK_ROOMS}
          bookings={MOCK_BOOKINGS}
          now={new Date('2026-05-10T14:23:00')}
          selectedRoomId={null}
          onSelect={() => {}}
          filter={filter}
        />
      </div>
    </AppLayout>
  );
}
